export const ANALYTICS_REPORT_TYPE = {
  general: 0,
  product: 1,
  event: 2
};
